import { render, staticRenderFns } from "./HoldingChart.vue?vue&type=template&id=0c3eb7c9&"
import script from "./HoldingChart.vue?vue&type=script&lang=js&"
export * from "./HoldingChart.vue?vue&type=script&lang=js&"
import style0 from "./HoldingChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports